import { render } from "./LayoutSidebar.vue?vue&type=template&id=fcf1e7ae&ts=true&lang=pug"
import script from "./LayoutSidebar.vue?vue&type=script&lang=ts"
export * from "./LayoutSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__